export default __webpack_public_path__ + "static/Imitatia-a99e20e3e69b14db292fcb052d775bb4.jpg";